module.exports = __webpack_public_path__ + "static/media/ico-player.2aa9cc2f.svg";